import { SequenceManagerAction } from '../actions/SequenceManagerAction';
import { mnpSendOtp, deliveryValidateOtp, rSendOtp } from "../api/api";

const MNPOTPVerificationAction = {
    MNP_OTP_VERIFICATION_VALUE : 'MNP_OTP_VERIFICATION_VALUE',
    MNP_VERIFICATION_OTP_INITIATE_SUCCESS : 'MNP_VERIFICATION_OTP_INITIATE_SUCCESS',
    MNP_VERIFICATION_OTP_VALIDATE_SUCCESS : 'MNP_VERIFICATION_OTP_VALIDATE_SUCCESS',
    MNP_VERIFICATION_OTP_RSEND_SUCCESS : 'MNP_VERIFICATION_OTP_RSEND_SUCCESS',
}


const OTPVerificationValue = (otp: any, offerContainerId: any) => {
    return function (dispatch: any) {
        dispatch({ type: MNPOTPVerificationAction.MNP_OTP_VERIFICATION_VALUE, payload: { otp: otp, offerContainerId: offerContainerId } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['MNPOTPVerification'] });
    }
}

const OTPInitiate = (msisdn: any, operator: any, lang: any, otpLength: any, isNumeric: any) => {
    return function (dispatch: any) {
        mnpSendOtp(msisdn, operator, lang, otpLength, isNumeric)
            .then((response) => {
                dispatch({ type: MNPOTPVerificationAction.MNP_VERIFICATION_OTP_INITIATE_SUCCESS, payload: response });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'sendCEMOTP' });
                const error = { ...err, config };

                if (error?.response) {
                    dispatch({ type: MNPOTPVerificationAction.MNP_VERIFICATION_OTP_INITIATE_SUCCESS, payload: error.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const OTPValidate = (otp: any, hashCode: any) => {
    return function (dispatch: any) {
        deliveryValidateOtp(otp, hashCode)
            .then((response) => {
                dispatch({ type: MNPOTPVerificationAction.MNP_VERIFICATION_OTP_VALIDATE_SUCCESS, payload: response });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'validateCEMOTP' });
                const error = { ...err, config };

                if (error?.response) {
                    dispatch({ type: MNPOTPVerificationAction.MNP_VERIFICATION_OTP_VALIDATE_SUCCESS, payload: error.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: { ...error, config } });
                }
            })
    }
}

const OTPResend = (hashCode: any) => {
    return function (dispatch: any) {
        rSendOtp(hashCode).then((response) => {
            dispatch({ type: MNPOTPVerificationAction.MNP_VERIFICATION_OTP_RSEND_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: MNPOTPVerificationAction.MNP_VERIFICATION_OTP_RSEND_SUCCESS, payload: error?.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

export { MNPOTPVerificationAction, OTPVerificationValue, OTPInitiate, OTPValidate, OTPResend };